import React, { useEffect, useRef, useState } from "react";
import img1 from "../../assets/images/Reasons/DSC03246.jpg";
import img2 from "../../assets/images/Reasons/DSC03303.jpg";
import img3 from "../../assets/images/Reasons/DSC03310.jpg";
import img4 from "../../assets/images/Reasons/DSC03445.jpg";
import { motion, AnimatePresence } from "framer-motion";

// Placeholder images - replace with your actual imports

import {
  CalendarIcon,
  HeartIcon,
  HandRaisedIcon,
  UsersIcon,
} from "@heroicons/react/24/outline"; // Using outline icons as in original

const reasonsData = [
  {
    id: "reason1",
    title: "9 ай – 9 тақырып", // 9 months - 9 topics
    desc: [
      "Құндылықтарға негізделген нақты құрылым.", // Clear structure based on values.
      "Әр ай – жеке бағыт, жүйелі тәрбие.", // Each month – a separate direction, systematic education.
    ],
    image: img3, // Replace with img3
    icon: <CalendarIcon className="h-6 w-6" />, // Icon for the tab
    label: "9 ай – 9 тақырып", // Label for the tab
  },
  {
    id: "reason2",
    title: "Құндылықты ертегілер", // Value-based fairy tales
    desc: [
      "Баланың жүрегіне жол табатын, ұлттық тәрбиеге негізделген ертегілер.", // Fairy tales that find a way to a child's heart, based on national education.
    ],
    image: img1, // Replace with img1
    icon: <HeartIcon className="h-6 w-6" />,
    label: "Ертегілер", // Fairy Tales (shorter label for tab)
  },
  {
    id: "reason3",
    title: "Бата арқылы тәрбиелеу", // Education through blessings
    desc: [
      "Әр құндылыққа арналған баталар – сөзбен сіңірілетін рухани тәрбие.", // Blessings for each value – spiritual education absorbed through words.
    ],
    image: img2, // Replace with img2
    icon: <HandRaisedIcon className="h-6 w-6" />,
    label: "Батамен тәрбие", // Blessing Education
  },
  {
    id: "reason4",
    title: "Ата-аналармен байланыс", // Communication with parents
    desc: [
      "Баланың белсенді қатысуын арттыратын, экраннан емес – өмірден үйрететін формат.", // A format that increases a child's active participation, teaching from life, not from the screen.
    ],
    image: img4, // Replace with img4
    icon: <UsersIcon className="h-6 w-6" />,
    label: "Ата-аналар", // Parents
  },
];

const Reasons = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRef = useRef(null);
  const activeReason = reasonsData[activeIndex];

  const handleIconClick = (index) => {
    setActiveIndex(index);
    // Optional: scroll to the top of the section when a new reason is selected
    // sectionRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % reasonsData.length);
    }, 10000); // 8000ms = 8 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return (
    <section
      ref={sectionRef}
      className="px-4 sm:px-6 lg:px-8 py-8  max-w-7xl mx-auto"
    >
      {/* Section Title and Description */}
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center text-[#674DA2] mb-5">
        Ustaz Kids-тің Басты Ерекшеліктері
      </h2>
      <p className="text-center max-w-3xl mx-auto text-gray-700 mb-8 md:mb-10 text-base md:text-lg">
        Біздің платформа тек құралдар жиынтығы емес, ол – бала тәрбиесіндегі
        сіздің сенімді серігіңіз. Әрбір элемент ойластырылған және сіздің
        жұмысыңызды жеңілдетуге бағытталған.
      </p>

      {/* Main Content Area: Text on Left, Image on Right */}
      <div className="relative min-h-[500px]">
        {" "}
        {/* Ensure consistent space */}
        <AnimatePresence mode="wait">
          <motion.div
            key={activeReason.id}
            initial={{ opacity: 0, x: 100 }} // Start off-screen to the right
            animate={{ opacity: 1, x: 0 }} // Animate into place
            exit={{ opacity: 0, x: -100, position: "absolute", width: "100%" }} // Exit off-screen to the left
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start mb-8 md:mb-12"
          >
            {/* Left Column: Text */}
            <div className="w-full lg:w-2/5 flex items-center">
              <div className="w-full pr-4 lg:pr-6">
                <div className="relative py-12">
                  <div className="absolute left-3 top-0 bottom-0 w-1 bg-[#674DA2] rounded-full"></div>
                  <div className="space-y-8 md:space-y-20">
                    <div className="relative pl-10">
                      <div className="absolute left-3 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-7 h-7 bg-white border-[3px] border-[#674DA2] rounded-full flex items-center justify-center z-10">
                        <div className="w-3 h-3 bg-[#674DA2] rounded-full"></div>
                      </div>
                      <h3 className="font-semibold text-2xl md:text-3xl text-[#674DA2] leading-tight">
                        {activeReason.title}
                      </h3>
                    </div>
                    {activeReason.desc.map((descItem, idx) => (
                      <div key={idx} className="relative pl-10">
                        <div className="absolute left-3 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-7 h-7 bg-white border-[3px] border-[#674DA2] rounded-full flex items-center justify-center z-10">
                          <div className="w-3 h-3 bg-[#674DA2] rounded-full"></div>
                        </div>
                        <p className=" text-base md:text-xl leading-relaxed">
                          {descItem}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column: Image */}
            <div className="w-full lg:w-4/5">
              <img
                src={activeReason.image}
                alt={activeReason.title}
                className="w-full h-auto max-h-[400px] md:max-h-[400px] object-cover rounded-2xl shadow-xl"
              />
            </div>
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Icon Tabs for selecting a reason */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-px border border-gray-200 rounded-xl overflow-hidden shadow-lg bg-gray-200">
        {reasonsData.map((reason, index) => (
          <button
            key={reason.id}
            onClick={() => handleIconClick(index)}
            className={`flex flex-col items-center justify-center p-4 md:p-6 transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#674DA2] focus-visible:ring-offset-2
              ${
                index === activeIndex
                  ? "bg-slate-50 border-t-4 border-[#674DA2]" // Active state styling
                  : "bg-white hover:bg-gray-50 border-t-4 border-transparent" // Inactive state
              }
            `}
            aria-current={index === activeIndex ? "true" : "false"}
            aria-label={`Select ${reason.label}`}
          >
            {/* Clone icon to apply dynamic classes */}
            {React.cloneElement(reason.icon, {
              className: `h-7 w-7 md:h-8 md:w-8 mb-2 ${
                index === activeIndex ? "text-[#674DA2]" : "text-gray-500"
              }`,
              "aria-hidden": "true",
            })}
            <span
              className={`text-xs sm:text-sm text-center font-semibold ${
                index === activeIndex ? "text-[#674DA2]" : "text-gray-700"
              }`}
            >
              {reason.label}
            </span>
          </button>
        ))}
      </div>
    </section>
  );
};

export default Reasons;
